import { Component, OnInit, Input } from '@angular/core';
@Component({
  selector: 'app-item-overview',
  templateUrl: './item-overview.component.html',
  styleUrls: ['./item-overview.component.scss']
})
export class ItemOverviewComponent implements OnInit {

  @Input() items = [];
  @Input() view: string = 'list';
  viewTypes = [
    { type: 'list', icon: 'fa fa-th-list' },
    { type: 'grid', icon: 'fa fa-th' },
  ];

  constructor() { }

  ngOnInit() {
  }

  setActiveView(type: string) {
    this.view = type;
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/item-overview/item-overview.component.ts